export enum SessionStorageKey {
  Token = 'token',
  Username = 'username',
  LoginRedirect = 'login-redirect',
}
